import { FloatingActionButton } from '@progress/kendo-react-buttons'
import clsx from 'clsx'
import { useEffect, useLayoutEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import type { Dispatch, SetStateAction } from 'react'
import siarlLogo from '../../assets/images/siarl_logo_sFundo.svg'
import pocurLogo from '../../assets/images/POSEUR_PT2020_FC_Bom.png';
import { coordenadasLinhaSelected, coordenadasPoligono, coordenadasSelected, getGeoPortalUser, getMenuItems, hasPermission, isUserLogged, mapStore, menuItemSelected, setCoordenadasLinhaSelected, setCoordenadasPoligono, setCoordenadasSelected, setMenuItemSelected, setMenuItems, userLogged } from '../../services/utils'
import styles from '../../styles/viewer/SidebarMenu.module.scss'
import { APOIO_GESTAO_MODULE_NAME, CONTACTENOS_MODULE_NAME,VOO_DRONE_MODULE_NAME, DOCUMENTOS_MODULE_NAME, DOMINIO_HIDRICO_MODULE_NAME, ENTIDADES_MODULE_NAME, GEOPORTAL_BACKOFFICE_URL, GEOPORTAL_MAPA_PUBLICO_URL, GEOVISUALIZADORES_MODULE_NAME, INICIO_MODULE_NAME, INTERVENCAO_MODULE_NAME, MODELOS_MODULE_NAME, OCORRENCIAS_MODULE_NAME, PERMISSION_BACKOFFICE, SOBRE_MODULE_NAME, USO_DO_SOLO_MODULE_NAME, PERMISSION_LISTAR_ENTIDADE, PERMISSION_MENU_ENTIDADE, PERMISSION_LISTAR_OCORRENCIA, PERMISSION_LISTAR_DOCUMENTOS, PERMISSION_LISTAR_INTERVENCAO, PERMISSION_LISTAR_INT_ACAO, PERMISSION_LISTAR_INT_MOBILIZACAO, PERMISSION_LISTAR_INT_CANDIDATURA, PERMISSION_LISTAR_AG_DESCONFORMIDADE, PERMISSION_LISTAR_AG_PRETENSAO, PERMISSION_LISTAR_DH_DEMARCACAO, PERMISSION_LISTAR_DH_PATRIMONIO, PERMISSION_LISTAR_US_TITULO, PERMISSION_LISTAR_US_VALOR, PERMISSION_LISTAR_GEOVISUALIZADORES, PERMISSION_LISTAR_ESTRATEGIA_ADAPTACAO, PERMISSION_SOBRE, PERMISSION_CONTACTENOS, PERMISSION_LISTAR_METADADOS, PERMISSION_LISTAR_INDICADORES, ESTRATEGIA_ADAPATACAO_MODULE_NAME, production, PERMISSION_OCORRENCIA_PERFIL_BASICO, PERMISSION_OCORRENCIA_PERFIL_COMPLETO_EDICAO, PERMISSION_OCORRENCIA_PERFIL_COMPLETO_LEITURA, PERMISSION_OCORRENCIA_PERFIL_INTERMEDIO_EDICAO, PERMISSION_OCORRENCIA_PERFIL_INTERMEDIO_LEITURA, PERMISSION_OCORRENCIA_PERFIL_TOTAL, PERMISSION_APOIO_GESTAOPERFIL_INTERMEDIO_EDICAO, PERMISSION_APOIO_GESTAOPERFIL_INTERMEDIO_LEITURA, PERMISSION_APOIO_GESTAO_PERFIL_BASICO, PERMISSION_APOIO_GESTAO_PERFIL_COMPLETO_EDICAO, PERMISSION_APOIO_GESTAO_PERFIL_COMPLETO_LEITURA, PERMISSION_APOIO_GESTAO_PERFIL_TOTAL, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_BASICO, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_TOTAL, PERMISSION_GEOVISUALIZADOR_PERFIL_BASICO, PERMISSION_GEOVISUALIZADOR_PERFIL_COMPLETO_EDICAO, PERMISSION_GEOVISUALIZADOR_PERFIL_COMPLETO_LEITURA, PERMISSION_GEOVISUALIZADOR_PERFIL_INTERMEDIO_EDICAO, PERMISSION_GEOVISUALIZADOR_PERFIL_INTERMEDIO_LEITURA, PERMISSION_GEOVISUALIZADOR_PERFIL_TOTAL, PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO, PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_LEITURA, PERMISSION_DOMINIO_HIDRICO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL, PERMISSION_DOMINIO_HIDRICO_PERFIL_BASICO, PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_BASICO, PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_COMPLETO_EDICAO, PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_COMPLETO_LEITURA, PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_TOTAL, CONTACTE_NOS_URL, PERMISSION_ENTIDADES_PERFIL_BASICO, PERMISSION_ENTIDADES_PERFIL_COMPLETO_EDICAO, PERMISSION_ENTIDADES_PERFIL_COMPLETO_LEITURA, PERMISSION_ENTIDADES_PERFIL_INTERMEDIO_EDICAO, PERMISSION_ENTIDADES_PERFIL_TOTAL, PERMISSION_USOSOLO_PERFIL_COMPLETO_LEITURA, PERMISSION_USOSOLO_PERFIL_COMPLETO_EDICAO, PERMISSION_USOSOLO_PERFIL_INTERMEDIO_EDICAO, PERMISSION_USOSOLO_PERFIL_TOTAL, PERMISSION_USOSOLO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_ENTIDADES_PERFIL_INTERMEDIO_LEITURA, PERMISSION_MODELO_PERFIL_BASICO, PERMISSION_MODELO_PERFIL_COMPLETO_EDICAO, PERMISSION_MODELO_PERFIL_COMPLETO_LEITURA, PERMISSION_MODELO_PERFIL_INTERMEDIO_EDICAO, PERMISSION_MODELO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_MODELO_PERFIL_TOTAL, PERMISSION_DOCUMENTOS_PERFIL_BASICO, PERMISSION_DOCUMENTOS_PERFIL_COMPLETO_EDICAO, PERMISSION_DOCUMENTOS_PERFIL_COMPLETO_LEITURA, PERMISSION_DOCUMENTOS_PERFIL_INTERMEDIO_EDICAO, PERMISSION_DOCUMENTOS_PERFIL_INTERMEDIO_LEITURA, PERMISSION_DOCUMENTOS_PERFIL_TOTAL, URL_SOBRE, NEWS_MODULE_NAME, URL_NEWS, METADADOS_MODULE_NAME, URL_METADADOS, PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_INTERMEDIO_LEITURA, URL_INDICADORES } from '../../utils/constants'
import { ocultaFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa_e_Mostra_Form, telaMobile } from '../common/ItemRenderMais'
import SessionStorageService from '../../services/SessionStorageService'
import useClearMap from '../../hooks/useClearMap'
export type Item = {
  icon: JSX.Element
  text: string
  selected: boolean
  route: string
  showButtons?: boolean
  action?: string,
  permissionName?: string[],
  module?: string
}

const menuItemsConst: Item[] = [
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-inicio'></span></span></>,
    text: 'Início',
    module: INICIO_MODULE_NAME,
    selected: true,
    action: "inicio",
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-dominiohidrico'></span></span></>,
    text: 'Domínio Hídrico',
    selected: false,
    module: DOMINIO_HIDRICO_MODULE_NAME,
    permissionName: [
      PERMISSION_DOMINIO_HIDRICO_PERFIL_BASICO,
      PERMISSION_DOMINIO_HIDRICO_PERFIL_INTERMEDIO_LEITURA,
      PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_LEITURA,
      PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO,
      PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL
      ,
    ],
    action: "pesquisarDominioHidrico",
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-intervencoes'></span></span></>,
    text: 'Intervenções',
    selected: false,
    module: INTERVENCAO_MODULE_NAME,
    permissionName: [PERMISSION_LISTAR_INTERVENCAO,
                    PERMISSION_LISTAR_INT_ACAO,
                    PERMISSION_LISTAR_INT_MOBILIZACAO,
                    PERMISSION_LISTAR_INT_CANDIDATURA,
                    PERMISSION_INTERVENCAO_PERFIL_BASICO,
                    PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA,
                    PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO,
                    PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO,
                    PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA,
                    PERMISSION_INTERVENCAO_PERFIL_TOTAL
                  ],
    action: "pesquisarIntervencao",
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-ocorrencias'></span></span></>,
    text: 'Ocorrências',
    selected: false,
    module: OCORRENCIAS_MODULE_NAME,
    permissionName:
    [
      //PERMISSION_LISTAR_OCORRENCIA,
      PERMISSION_OCORRENCIA_PERFIL_BASICO,
      PERMISSION_OCORRENCIA_PERFIL_COMPLETO_EDICAO,
      PERMISSION_OCORRENCIA_PERFIL_COMPLETO_LEITURA,
      PERMISSION_OCORRENCIA_PERFIL_INTERMEDIO_EDICAO,
      PERMISSION_OCORRENCIA_PERFIL_INTERMEDIO_LEITURA,
      PERMISSION_OCORRENCIA_PERFIL_TOTAL
    ],
    action: "consultaOcorrencias",
    route: '/ocorrencia/terreno/registar',
    showButtons: true,
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-usosdosolo'></span></span></>,
    text: 'Usos de solo',
    module: USO_DO_SOLO_MODULE_NAME,
    selected: false,
    permissionName: [PERMISSION_LISTAR_US_TITULO,
                    PERMISSION_LISTAR_US_VALOR,
                    PERMISSION_USOSOLO_PERFIL_COMPLETO_LEITURA,
                    PERMISSION_USOSOLO_PERFIL_COMPLETO_EDICAO,
                    PERMISSION_USOSOLO_PERFIL_INTERMEDIO_EDICAO,
                    PERMISSION_USOSOLO_PERFIL_INTERMEDIO_LEITURA,
                    PERMISSION_USOSOLO_PERFIL_TOTAL],
    route: '/',
    action: "pesquisarUsoDoSolo",
    showButtons: true
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-geovisualizadores'></span></span></>,
    text: 'Geovisualizadores',
    module: GEOVISUALIZADORES_MODULE_NAME,
    selected: false,
    permissionName: [PERMISSION_LISTAR_GEOVISUALIZADORES,
      PERMISSION_GEOVISUALIZADOR_PERFIL_BASICO,
      PERMISSION_GEOVISUALIZADOR_PERFIL_COMPLETO_EDICAO,
      PERMISSION_GEOVISUALIZADOR_PERFIL_COMPLETO_LEITURA,
      PERMISSION_GEOVISUALIZADOR_PERFIL_INTERMEDIO_EDICAO,
      PERMISSION_GEOVISUALIZADOR_PERFIL_INTERMEDIO_LEITURA,
      PERMISSION_GEOVISUALIZADOR_PERFIL_TOTAL
    ],
    route: '/',
    action: "listarGeovisualizadores",
    showButtons: true
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-apoiogestao'></span></span></>,
    text: 'Apoio à Gestão',
    module: APOIO_GESTAO_MODULE_NAME,
    action: 'pesquisarApoioGestaoPretensao',
    permissionName: [
      PERMISSION_LISTAR_AG_DESCONFORMIDADE,
      PERMISSION_LISTAR_AG_PRETENSAO,
      PERMISSION_APOIO_GESTAOPERFIL_INTERMEDIO_EDICAO,
      PERMISSION_APOIO_GESTAOPERFIL_INTERMEDIO_LEITURA,
      PERMISSION_APOIO_GESTAO_PERFIL_BASICO,
      PERMISSION_APOIO_GESTAO_PERFIL_COMPLETO_EDICAO,
      PERMISSION_APOIO_GESTAO_PERFIL_COMPLETO_LEITURA,
      PERMISSION_APOIO_GESTAO_PERFIL_TOTAL
    ],
    selected: false,
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-estrategiaadaptacao'></span></span></>,
    text: 'Estratégia de Adaptação',
    selected: false,
    module: ESTRATEGIA_ADAPATACAO_MODULE_NAME,
    permissionName: [PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_BASICO,
      PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_INTERMEDIO_LEITURA,
    PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_COMPLETO_LEITURA,
    PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_COMPLETO_EDICAO,
    PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_TOTAL 
    
    ],

    action: "pesquisarEstrategiaAdaptacao",
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-diretorioentidades'></span></span></>,
    text: 'Diretório de Entidades',
    module: ENTIDADES_MODULE_NAME,
    action: 'diretorioEntidades',
    permissionName: [PERMISSION_MENU_ENTIDADE,
    PERMISSION_ENTIDADES_PERFIL_BASICO,
    PERMISSION_ENTIDADES_PERFIL_COMPLETO_EDICAO,
    PERMISSION_ENTIDADES_PERFIL_COMPLETO_LEITURA,
    PERMISSION_ENTIDADES_PERFIL_INTERMEDIO_EDICAO,
    PERMISSION_ENTIDADES_PERFIL_INTERMEDIO_LEITURA,
    PERMISSION_ENTIDADES_PERFIL_TOTAL],
    selected: false,
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-modelos'></span></span></>,
    text: 'Modelos',
    module: MODELOS_MODULE_NAME,
    selected: false,
    action: "pesquisarModelos",
    permissionName: [PERMISSION_MODELO_PERFIL_BASICO,
                    PERMISSION_MODELO_PERFIL_COMPLETO_EDICAO,
                    PERMISSION_MODELO_PERFIL_COMPLETO_LEITURA,
                    PERMISSION_MODELO_PERFIL_INTERMEDIO_EDICAO,
                    PERMISSION_MODELO_PERFIL_INTERMEDIO_LEITURA,
                    PERMISSION_MODELO_PERFIL_TOTAL],
    route: '/',
    showButtons: true,
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-documentos'></span></span></>,
    text: 'Documentos',
    module: DOCUMENTOS_MODULE_NAME,
    permissionName: [PERMISSION_LISTAR_DOCUMENTOS,
                    PERMISSION_DOCUMENTOS_PERFIL_BASICO,
                    PERMISSION_DOCUMENTOS_PERFIL_COMPLETO_EDICAO,
                    PERMISSION_DOCUMENTOS_PERFIL_COMPLETO_LEITURA,
                    PERMISSION_DOCUMENTOS_PERFIL_INTERMEDIO_EDICAO,
                    PERMISSION_DOCUMENTOS_PERFIL_INTERMEDIO_LEITURA,
                    PERMISSION_DOCUMENTOS_PERFIL_TOTAL],
    selected: false,
    action: "pesquisarDocumentos",
    route: '/',
    showButtons: true,
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-indicadores'></span></span></>,
    text: 'Indicadores',
    action: "indicadores",
    selected: false,
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-metadados'></span></span></>,
    text: 'Metadados',
    module: METADADOS_MODULE_NAME,
    selected: false,
    action: "metadados",
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-sobre'></span></span></>,
    text: 'Sobre',
    module: SOBRE_MODULE_NAME,
    // permissionName: [PERMISSION_SOBRE],
    selected: false,
    action: "sobre",
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-noticias'></span></span></>,
    text: 'Notícias',
    module: NEWS_MODULE_NAME,
    selected: false,
    action: "news",
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-contatos'></span></span></>,
    text: 'Contacte-nos',
    module: CONTACTENOS_MODULE_NAME,
    // permissionName: [PERMISSION_CONTACTENOS],
    selected: false,
    action: "Contactenos",
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl icon-bo'></span></span></>,
    action: 'Backoffice',
    permissionName: [PERMISSION_BACKOFFICE],
    module: "Backoffice",
    text: 'Backoffice',
    selected: false,
    route: '/',
  },
  
  
]

const menuItemsBackofficeConst = [
  {
    icon: <><span className={styles.icon}><span className='icon-siarl'></span></span></>,
    action: 'BackofficeGeoportal',
    permissionName: [PERMISSION_BACKOFFICE],
    module: "Backoffice",
    text: 'Mapa',
    selected: false,
    route: '/',
  },
  {
    icon: <><span className={styles.icon}><span className='icon-siarl' ></span></span></>,
    action: 'BackofficeClassificadores',
    permissionName: [PERMISSION_BACKOFFICE],
    module: "Backoffice",
    text: 'Classificadores',
    selected: false,
    route: '/',
  },
]

type Props = {
  setSelectedMenuItem: Dispatch<SetStateAction<Item>>
}

export default function SidebarMenu({ setSelectedMenuItem }: Props) {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate()
  const [showBtns, setShowBtns] = useState(false)
  const [addRoute, setAddRoute] = useState('')
  const [showPopover, setShowPopover] = useState(false)
  const setGPUrl = mapStore((state: any) => state.setUrl);
  const gpUrl = mapStore((state: any) => state.url);
  const [displaySubmenuBackoffice, setDisplaySubmenuBackoffice] = useState('none');
  let menuItemLocal: any[];


  //const [menuItems, setMenuItems] = useState<any>(menuItemsConst.slice());

  //let menuItems: any[] = menuItemsConst;

  const backofficeMenu = {
   
  }

  useEffect(() => {
    const checkUser =()=>{
      if (isUserLogged()) {
        const _menuItems =menuItemsConst.slice(); 
        setMenuItems(_menuItems);
        const selected = _menuItems?.filter((item: any) => item.selected === true)[0]
        setSelectedMenuItem(selected);
        openMenus(_menuItems);
      }
    }
    checkUser();
  }, [])

  const openMenus = (menuItems: any) => {
    for (let i = 0; i < menuItemsConst.length; i++) {
      const permissionNames = menuItemsConst[i].permissionName;
      if (permissionNames) {
        let contPermissionsBlocked = 0;
        for (let j=0; j< permissionNames.length; j++) {
          const permissionName = permissionNames[j];
          if (!hasPermission(permissionName)) {
            contPermissionsBlocked++;
          }
        }
        if (contPermissionsBlocked == permissionNames.length) {
          for (let j = 0; j < menuItems.length; j++) {
            if (menuItems[j].action == menuItemsConst[i].action) {
              menuItems.splice(j, 1);
              setMenuItems(menuItems);
            }
          }
        } else {
          const itemExist = menuItems.some((x: any) => x.action == menuItemsConst[i].action);
          if (!itemExist) {
            menuItemLocal = menuItemsConst.slice();
            menuItemLocal.push(backofficeMenu);
            setMenuItems(menuItemLocal);
            //menuItems = menuItemLocal;
          }
        }
      }
    }
    
  }

  // useEffect(() => {
  //   addEventListener(
  //     'message',
  //     (event: MessageEvent) => {
  //       if (event.data.type == "MapLoaded") {
  //         postMessage({ type: 'hideLoader' }, '*');
  //         postMessage({ type: "form", value: menuItemSelected }, "*");
  //       }
  //     },
  //     false
  //   );
  // }, [])

  const redirectRoute = (item: Item) => {
    SessionStorageService.setItem("firstCallUsTitulo", true);
    SessionStorageService.setItem("firstCallModelos", true);
    SessionStorageService.setItem("firstCallAgPretensao", true);
    SessionStorageService.setItem("firstCallAgDesconformidade", true);
    SessionStorageService.setItem("firstCallOcorrencias", true);
    SessionStorageService.setItem("firstCallIntervencao", true);
    SessionStorageService.setItem("firstCallAcao", true);
    SessionStorageService.setItem("firstCallCandidatura", true);
    SessionStorageService.setItem("firstCallMobilizacao", true);
    SessionStorageService.setItem("firstCallEntidade", true);
    SessionStorageService.setItem("firstCallDocumentoAvancada", true);
    SessionStorageService.setItem("firstCallDocumentoSimples", true);
    SessionStorageService.setItem("firstCallAnalise", true);
    SessionStorageService.setItem("firstCallFotoObliqua", true);
    SessionStorageService.setItem("firstCallVooDrone", true);
    SessionStorageService.setItem("firstCallProcesso", true);
    SessionStorageService.setItem("firstCallPatrimonio", true);
    SessionStorageService.setItem("firstCallDemarcacao", true);
    SessionStorageService.removeItem("dhAutoVerticePointSelected")
    if (item.action == "sobre") {
      window.open(URL_SOBRE, '_blank');
      return;
    }
    if (item.action == "news") {
      window.open(URL_NEWS, '_blank');
      return;
    }
    if (item.action == "metadados") {
      window.open(URL_METADADOS, '_blank');
      return;
    }
    if (item.action == "indicadores") {
      window.open(URL_INDICADORES, '_blank');
      return;
    }
    if (item.action == "Backoffice") {
      if (displaySubmenuBackoffice == 'none') {
      setDisplaySubmenuBackoffice('block');
      } else {
        setDisplaySubmenuBackoffice('none');
      }
      return;
    }
    if (item.action == "BackofficeGeoportal") {
      postMessage({type:"showLoader"}, "*");
      const iframe: any = document.getElementById('iframeGeoPortal');
        setTimeout(() => {
          iframe.contentWindow?.postMessage({
            type: "DoSiarlGeoPortalLogin",
            user: getGeoPortalUser()
          }, "*");
          setTimeout(() => { 
            postMessage({type: "hideLoader"}, "*");
            setGPUrl(GEOPORTAL_BACKOFFICE_URL);
          }, 2000);
        }, 500);
        postMessage({ type: "hideFloatingMenu", value: "true" }, "*");
        // setTimeout(() => {
        //   sendUserLogin();
        // }, 1000);
        return;
    }
    else {
      postMessage({ type: "showFloatingMenu", value: "true" }, "*");
    }
    
    if (item.action) {
      
      setMenuItemSelected(item.action);
      if (gpUrl == GEOPORTAL_BACKOFFICE_URL || gpUrl == CONTACTE_NOS_URL) {
        setGPUrl(GEOPORTAL_MAPA_PUBLICO_URL);
      }
      if (item.module) {
        const userLoginSended = sessionStorage.getItem('userLoginSended');
        limparFiltrosPesquisa();
        sessionStorage.setItem("Modulo", item.module);

        if (item.module != DOMINIO_HIDRICO_MODULE_NAME &&
          item.module != APOIO_GESTAO_MODULE_NAME &&
          item.module != INTERVENCAO_MODULE_NAME) {
          sessionStorage.removeItem("SubModulo");
        }

        sessionStorage.setItem("userLoginSended", userLoginSended ?? "");
      }
      postMessage({ type: "form", value: item.action }, "*");
      return
    } else {
      setShowBtns(false)
    }
    navigate(item.route)
  }


  const limparFiltrosPesquisa = async () => {
        if (coordenadasLinhaSelected) {
          setCoordenadasLinhaSelected(undefined);
        }
        if (coordenadasPoligono) {
          setCoordenadasPoligono(undefined);
        }
        if (coordenadasSelected) {
          setCoordenadasSelected(undefined);
        }

        const iframe: any = document.getElementById('iframeGeoPortal')
        //iframe.contentWindow?.postMessage({ type: "SiarlClearLayers", value: 'true' }, '*')
        iframe.contentWindow?.postMessage(
            {
                type: 'SiarlHideInfoMap',
                value: 'true',
            },
            '*'
        )
        iframe.contentWindow?.postMessage({ type: "SiarlUsTituloClearLayers", value: "true" }, '*')
        iframe.contentWindow?.postMessage({ type: "SiarlCoordenadaBoxClose", value: "true" }, '*')
    }

  const clickMenuItem = (item: Item) => {
    getMenuItems()?.map((currentItem: any) => {
      currentItem.selected = false
    })

    if (item.module != OCORRENCIAS_MODULE_NAME &&
      item.module != ENTIDADES_MODULE_NAME &&
      item.module != DOCUMENTOS_MODULE_NAME &&
      item.action != 'Backoffice' &&
      item.action != 'BackofficeGeoportal' &&
      item.action != 'sobre' &&
      item.action != 'news' &&
      item.module != INICIO_MODULE_NAME &&
      !!production) {
        // const itemLocal = {
        //   icon: <><span className={styles.icon}><span className='icon-siarl icon-inicio'></span></span></>,
        //   text: 'Início',
        //   module: INICIO_MODULE_NAME,
        //   selected: true,
        //   action: "inicio",
        //   route: '/',
        // }
        //itemLocal.selected = true

        //console.log(itemLocal);
        //redirectRoute(itemLocal)
        //setSelectedMenuItem(itemLocal)
        postMessage({type: "infoMsg", value: {message: "Em carregamento de dados"}}, "*");
        //return;
      }
    item.selected = true
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
       {
         type: 'SiarlCoordenadaBoxClose',
         value: 'true',
       },
       '*'
     )
    console.log(item);
    redirectRoute(item)
    setSelectedMenuItem(item)
    if (item.action != "Backoffice" &&
    !sessionStorage.getItem("Modulo")) {
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      {
        type: 'SiarlMapCenter',
        value: "true",
      },
      '*'
    )
  }
  }

  useLayoutEffect(() => {

    const handleResize = () => {

      if (window.innerWidth <= telaMobile) {
        
        setIsMobile(true);

      }else{

        setIsMobile(false);

      }

    };
  
    window.addEventListener('resize', handleResize);
  
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);  

  return (
    <>
      <div
        className={styles.base}
        id='base'
        key={"base"}
      >
        <div className={styles.logoWrapper}>
          <img
            src={siarlLogo}
            className={styles.logo}
            alt="Siarl - Sistema de Administração do Recurso Litoral"
          />
        </div>
        <ul className={styles.menu}>
          {getMenuItems()?.map((item: any, index: any) => (
            <li
              key={`key_${item.text}_${item.index}_`}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                clickMenuItem(item)

                if (isMobile) {
                  setTimeout(() => {
                    ocultaFloatingMenu_e_Mapa_e_Mostra_Form();
                  }, 0);
                }  

              }}
              className={clsx(styles.item, item.selected && styles.selected)}
            >
              {item.icon}
              <span className={styles.itemText}>{item.text}</span>
            </li>
          ))}
          {menuItemsBackofficeConst?.map((item: any, index: any) => (
            <li
              key={`key_${item.text}_${item.index}_`}
              style={{ cursor: 'pointer', display: displaySubmenuBackoffice }}
              onClick={() => {
                clickMenuItem(item)

                if (isMobile) {
                  setTimeout(() => {
                    ocultaFloatingMenu_e_Mapa_e_Mostra_Form();
                  }, 0);
                }  

              }}
              className={clsx(styles.item, item.selected && styles.selected)}
            >
              {item.icon}
              <span style={{paddingLeft: '20px'}} className={styles.itemText}>{item.text}</span>
            </li>
          ))}
        </ul>
        <img
          src={pocurLogo}
          className={'logoPOCURMenu'}
          alt="POCUR"
        />
      </div>
      
      {showBtns && (
        <>
          <FloatingActionButton
            text={'Registar'}
            icon={'plus-circle'}
            align={{ horizontal: 'start', vertical: 'top' }}
            alignOffset={{ y: 27, x: 776 }}
            positionMode="absolute"
            onClick={() => {
              const iframe: any = document.getElementById('iframeGeoPortal')
              iframe.contentWindow?.postMessage(
                { type: 'SiarlGeoPortalRegistarOcorrenciaTerreno', value: 'true' },
                '*'
              );

              sessionStorage.setItem("Modulo", "Ocorrencias");
            }}
          />
          <FloatingActionButton
            text={'Consultar'}
            icon={'search'}
            align={{ horizontal: 'start', vertical: 'top' }}
            alignOffset={{ y: 27, x: 930 }}
            positionMode="absolute"
            onClick={() => {
              postMessage({ type: "showConsultaOcorrencia", value: "true" }, "*");
            }}
          />
        </>
      )}
    </>
  )
}
